module.exports = new __parcel__URL__("artifact_0005.bd293b78.png").toString();